import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'news',
    template: require('./news.component.html')
})
export class NewsComponent implements OnInit {
    id: number;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router) {

    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/news/news.component.ts
 **/